import { render, staticRenderFns } from "./iDSGoTop.vue?vue&type=template&id=74fdfb37"
import script from "./iDSGoTop.vue?vue&type=script&lang=js"
export * from "./iDSGoTop.vue?vue&type=script&lang=js"
import style0 from "./iDSGoTop.vue?vue&type=style&index=0&id=74fdfb37&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports